import { defineMessages } from 'react-intl';

export default defineMessages({
    additionalInformationTitle: {
        id: "quoteandbind.wizard.commercial.TWIA.Additional Information.Title",
        defaultMessage: "Additional Information"
    },
    addtnlInfoCondoAssocTwiaErrorMsg: {
        id: "quoteandbind.wizard.commercial.TWIA.Additional Information.CondoAssocTwiaErrorMsg.A Condo Assoc. By-Laws must be uploaded for this application. Please use \"N/A\" in the Building selection.",
        defaultMessage: "A Condo Assoc. By-Laws must be uploaded for this application. Please use \"N/A\" in the Building selection."
    }
})